function formatAnnouncementDate(dateStr: string): string {
  const [yy, mm, dd] = dateStr.split("-").map(Number);
  const fullYear = 2000 + yy;
  return `${fullYear}.${String(mm).padStart(2, '0')}.${String(dd).padStart(2, '0')}`;
}

export default formatAnnouncementDate;